<!-- @Version: 1.0.3 -->
@if (done$$() == true) {
   <form [formGroup]="fgRadio" data-testid="radiocontainer">
      <div>
         <mat-radio-group  [color]="TRANSLATE_PATH.COLOR_RADIO | translateDesign" class="check-row" data-testid="radiogroup"  [ngClass]="(fieldItem.attribute_4 && fieldItem.attribute_4 == DIRECTION.VERTICAL) ? DIRECTION.VERTICAL : DIRECTION.HORIZONTAL" [formControlName]="FC_RADIO.RADIOBUTTON">
         @for (radio of sFieldItemRadio.radioButtons; track radio; let idx = $index) {
            <mat-radio-button tabindex="0" cdkMonitorElementFocus class="flex-item" [attr.data-testid]="'mat-radio' + idx" [value]="radio.value" [checked]="isChecked(radio.value)">
               {{radio.label}}
            </mat-radio-button>
         }
         </mat-radio-group>
      </div>
      <ng-container class="error-messages">
         @if (fgRadio.errors && fgRadio.dirty && fgRadio.errors.required && !fgRadio.errors.valid) {
            <mat-error [attr.data-testid]="'error-required'">{{sFieldItemRadio.errorCodes.errorCodeRequired}}</mat-error>
         }
         @if (fgRadio.errors && fgRadio.dirty && fgRadio.errors.valid) {
            <mat-error [attr.data-testid]="'error-valid'">{{sFieldItemRadio.errorCodes.errorCodeValid}}</mat-error>
         }
         @if (fieldItem.required && !fgRadio.disabled && !(fgRadio.errors && fgRadio.dirty && fgRadio.errors.required && !fgRadio.errors.valid)) {
            <mat-hint [attr.data-testid]="'hint-required'">{{TRANSLATE_PATH.REQUIRED  | translateDesign}}</mat-hint>
         }
         @if (!(fgRadio.errors && fgRadio.dirty && fgRadio.errors.required && !fgRadio.errors.valid) && !(fgRadio.errors && fgRadio.dirty && fgRadio.errors.valid) && !(fieldItem.required && !fgRadio.disabled && !(fgRadio.errors && fgRadio.dirty && fgRadio.errors.required && !fgRadio.errors.valid))) {
            <mat-hint> </mat-hint>
         }
      </ng-container>
   </form>
}
